module.exports = __webpack_public_path__ + "img/box_parked.d03e2e7c.svg";